import cn from 'classnames'
import * as React from 'react'

import { ErrorText, IFormInput, Label } from '..'

import styles from './toggle.module.scss'

interface IToggle<T> extends IFormInput<T> {
  checked: boolean
  center?: boolean
  variant?: 'toggle' | 'checkbox'
  value?: string
}

export default function Toggle<T>({
  center = false,
  checked,
  errorMessage = '',
  input,
  label = '',
  name,
  valid = 'unknown',
  variant = 'toggle',
  ...rest
}: IToggle<T> & React.InputHTMLAttributes<HTMLInputElement>) {
  const isInvalid = valid === 'invalid'

  return (
    <div className={cn(styles.root, variant === 'checkbox' && styles.rootCheckbox)}>
      <div className={cn(styles.row, center && styles.alignCenter)}>
        {variant === 'checkbox' ? (
          <label className={styles.checkboxContainer}>
            <input {...input.checkbox(name, rest.value)} {...rest} />
            <span className={styles.checkmark} />
            {label && <span className={styles.textLabel}>{label}</span>}
          </label>
        ) : (
          <>
            <label
              {...input.label(name)}
              className={cn(styles.toggleContainer, checked && styles.checked, isInvalid && styles.error)}
            >
              <div className={cn(styles.toggleSwitch, checked && styles.checked)} />
              <input style={{ opacity: 0 }} {...input.checkbox(name)} className={styles.input} {...rest} />
            </label>
            {label && (
              <Label className={styles.textLabel} input={input} name={name}>
                {label}
              </Label>
            )}
          </>
        )}
      </div>
      {isInvalid && <ErrorText>{errorMessage}</ErrorText>}
    </div>
  )
}
